// extracted by mini-css-extract-plugin
export default {"copy-icon":"CopyBtn_copy-icon__G3Ata","copy-icon-one":"CopyBtn_copy-icon-one__lVfyx","copy-message":"CopyBtn_copy-message__UprqL","fade-out":"CopyBtn_fade-out__vcmbz"};